import Vue from 'vue'
import moment from 'moment'
import baseApplicationItem from './baseApplicationItem'
import { merge } from 'lodash'

const module = {
  endpoint: 'product',
  getNew: {
    deleted: false,
    name: null,
    season: null,
    year: moment().year(),
    vat: {},
    brand: {},
    categories: [],
    subcategories: [],
    sections: [],
    technicalDetails: [],
    sellables: [],
    sex: null,
    variants: [],
  },
  tableInfo: {
    tableFields: [
      {
        name: '__component:badge-deleted-column',
        title: '',
        dataClass: 'text-center'
      },
      {
        name: '__checkbox',
        title: '',
        class: 'primary'
      },
      {
        name: 'id',
        title: 'id',
        sortField: 'id'
      },
      {
        name: 'name',
        title: 'nome',
        sortField: 'name'
      },
      {
        name: 'brand.name',
        title: 'brand',
        sortField: 'brand'
      },
      {
        name: 'category.name',
        title: 'categoria',
        sortField: 'category.name'
      },
      {
        name: 'year',
        title: 'anno',
        sortField: 'year'
      },
      {
        name: 'subCategory.name',
        title: 'sotto categoria',
        sortField: 'subCategory.name'
      },
      {
        name: '__component:actions-column',
        title: '',
        dataClass: 'text-center'
      }
    ],
    sortFunctions: {
    }
  },
  async getImageUrl (productId, variantId, imageName) {
    let url = `admin/catalog/product/asset?product=${productId || '%%PRODUCTID'}&variant=${variantId || '%%VARIANTID'}&image=${imageName}`
    let resultUrl = (await Vue.http.get(url)).body.url
    return resultUrl
  },
  async uploadAssets (model, productId) {
    async function asyncForEach (array, callback) {
      for (let index = 0; index < array.length; index++) {
        await callback(array[index], index, array)
      }
    }

    let productOnDb = {}

    // se c'è almeno una variante appena inserita recupero l'intero prodotto da db per recuperare i variant id appena inseriti
    if (model.variants && model.variants.filter(function (item) { return item.isNewVariant }).length > 0) {
      productOnDb = await this.get(productId)
      productOnDb.variants.forEach(variant => {
        variant.productAsset.forEach(asset => {
          asset.thumbUrl = asset.thumbUrl.replace('/%%PRODUCTID/', `/${productOnDb.id}/`).replace('/%%VARIANTID/', `/${variant.id}/`)
          asset.url = asset.url.replace('/%%PRODUCTID/', `/${productOnDb.id}/`).replace('/%%VARIANTID/', `/${variant.id}/`)
        })
      })

      // TODO: workaround brand
      productOnDb.brand = model.brand
      // risalvo il prodotto con i product id e variant id corretti negli assets
      await this.save(productOnDb)
    }


    await asyncForEach(model.variants, async (variant) => {
      await asyncForEach(variant.productAsset, async (asset) => {
        if (variant.isNewVariant) {
          // il match lo faccio utilizzando lo sku, presupponendo sia univoco.
          let productVariantFromDb = productOnDb.variants.filter(function (item) { return item.sku === variant.sku })
          if (productVariantFromDb.length === 1) {
            variant.id = productVariantFromDb[0].id

            asset.thumbUrl = asset.thumbUrl.replace('/%%PRODUCTID/', `/${productId}/`).replace('/%%VARIANTID/', `/${variant.id}/`)
            asset.url = asset.url.replace('/%%PRODUCTID/', `/${productId}/`).replace('/%%VARIANTID/', `/${variant.id}/`)
          } else {
            // todo gestire eventuale errore, ma come?
          }
        }

        if (asset.file) {
          let formData = new FormData()
          // input.push(asset) // todo
          // append params
          formData.append('productId', productId)
          formData.append('variantId', variant.id)
          formData.append('fileName', asset.url)

          // append file
          // debugger
          formData.append('theFile', asset.file, asset.file.name)
          // formData.append('theFile', fileInput, 'mypic.jpg')

          // POST file to sails app
          console.log('uploading file...')
          try {
            let result = await Vue.http.post('admin/catalog/product/asset', formData)
            console.log('upload a file')
            console.log(result)
          } catch (error) {
            console.error('error during uploading a file', error)
          }
          // return result
        }
      })
    })
    console.log('all uploads done')
  },
}

export default merge(module, baseApplicationItem)



// WEBPACK FOOTER //
// ./src/application/products.js